







































import { Vue, Prop, Component } from 'vue-property-decorator'
import noData from './noData.vue'
import * as util from '../../util.js'
@Component
export default class Coupon extends Vue {
  @Prop({ default: [] }) couponList: any
  @Prop({ default: '' }) courseId: any
  hidePopup() {
    this.$emit("hideCoupon")
  }
  async obtainCoupon(coupon) {
    if (+coupon.per_count <= +coupon.collected_num) return this.$Toast(`已达到领取上限`)
    let { data } = await this.$axios.post(`/api/mobile/coupon/coupon/acquireCoupon`, {
      couponId: coupon.id,
      activityId: coupon.activity_id
    })
    this.$Toast('领取成功')
    await this.$emit("getCouponList")
    this.courseId && this.hidePopup()
  }
  userCoupon(coupon) {
    if (this.courseId) return this.hidePopup()
    this.$router.push({
      path: "/channelList",
      query: {
        couponId: coupon.id,
        usedScope: coupon.used_scope
      }
    })
  }
  async mounted() {
    await this.$store.login()
  }
}
